import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import ComboBox from '../../../../components/ComboBox';
import SelectUserComboBox from '../../../../components/SelectUserComboBox';
import UserAvatar from '../../../../components/UserAvatar';
import LoadingDots from '../../../../components/LoadingDots';
import dataModel from '../../../../models/DataModel';
import CollectionDataSource from '../../../../dao/DataSource/CollectionDataSource';
import { location_shallow } from '../../../../dao/collections/LocationsCollection';
import * as BuildOwnerPermissionsUtil from '../../../../helpers/permissions/BuildOwnerPermissionsUtil';
import './NewBuildCard.scss';
import Input from '../../../../components/Input';

// Projects Build card
export class NewBuildCard extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { 
      editBuild: { name: '', user_build_assignments: [] },
      currentBuildOwners: [],
      locations: null,
      totalLocation: null,
      locationsList: null,
      currentLocation: null,
      locationChanged: false,
    };
  }

  handleLocationsRetrieval(locationsCollection) {
    const { project } = this.props;
    this.setState({
      locations: locationsCollection.locations,
      currentMarketId: project.market_id,
      currentLocation: project.location_id ? project.location : null, loadingLocations: false,
      totalLocation: locationsCollection.meta.total_records,
    });
  }

  componentDidMount() {
    if (this.inputField) {
      this.inputField.focus();
    }
    this.getLocations();

    const createLocationList =  this.createLocationOptions();
    this.setState({ locationsList: createLocationList }); 
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.locations !== this.state.locations) {
      const createLocationList = this.createLocationOptions();
      this.setState({ locationsList: createLocationList });
    }
  }

  componentWillUnmount() {
    if (this.locationsDataSource) {
      this.locationsDataSource.release();
      this.locationsDataSource = null;
    }  
  }

  handleNameChanged(e) {
    if (!this.state.editBuild.name && !e.target.value) {
      return;
    }
    if(e.target.value.trim() !== '' || !e.target.value){
      let editedBuild = Object.assign({}, this.state.editBuild, { name: e.target.value });
      this.setState({ editBuild: editedBuild, nameChanged: e.target.value && e.target.value != '' });
      dataModel.dataChanged = (e.target.value && e.target.value != '') || this.state.userAssignmentsChanged;
    }
  }

  handleClick(e){
    const { handleNewCardSelected } = this.props;
    if (handleNewCardSelected){
      handleNewCardSelected(this.props.selected ? false : true);
    }
  }

  handleCreateBuild(){
    const { handleCreate, parent } = this.props;
    if (!this.state.editBuild.name) {
      dataModel.displayWarnErrorMessage('Please supply a name for this build.',
        4000, 2);
    }
    else if (this.state.editBuild && this.state.editBuild.name) {
      if (handleCreate && parent) {
        if (this.state.currentBuildOwners) {
          this.state.editBuild.user_build_assignments = BuildOwnerPermissionsUtil.addBuildOwnersToUserAssignments(this.state.editBuild.user_build_assignments, this.state.currentBuildOwners);
        }
        handleCreate(this.state.editBuild, parent);
      }
      this.handleClearBuild();
    }
  }

  handleClearBuild(){
    const { project } = this.props;
    this.setState({
      editBuild: { name: '', user_build_assignments: [] },
      currentBuildOwners: [], nameChanged: false, userAssignmentsChanged: false,
      currentLocation: project.location_id ? project.location : null,
    });
    dataModel.dataChanged = false;
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      e.preventDefault();
      this.handleCreateBuild();
    }
    else if (e.keyCode == 27) {
      e.preventDefault();
      this.handleClearBuild();
    }
  }

  createNotifyMemberArray(userList, type) {
    if (userList) {
      return userList.map(user => {
        return <UserAvatar id={'user-avatar-build-crud' + type + user.id} key={'user-avatar-build-crud' + user.id} user={user} small={true} />;
      });
    }
    else {
      return null;
    }
  }

  makeUserAssigments(type, multipleSelections, selectedOption) {
    const editedBuild = Object.assign({}, this.state.editBuild);

    let user_build_assignment = editedBuild.user_build_assignments ? editedBuild.user_build_assignments.filter(bUser => {
      return bUser.user_id == selectedOption.user.id || (bUser.user && bUser.user.id == selectedOption.user.id);
    }) : [];
    if (selectedOption.selected) {
      // See if there was already a user of that type

      if (user_build_assignment.length == 0) {
        editedBuild.user_build_assignments.push({ assignment_type: type, user: selectedOption.user, toBeAdded: true });
      }
      else {
        user_build_assignment[0].assignment_type = type;
        user_build_assignment[0].toBeAdded = true;
      }
    }
    else {
      if (user_build_assignment[0].id) {
        user_build_assignment[0].toBeDeleted = true;
      }
      else {
        const index = editedBuild.user_build_assignments.indexOf(user_build_assignment[0]);
        if (index >= 0) {
          editedBuild.user_build_assignments.splice(index, 1);
        }
      }
    }
    this.setState({ editBuild: editedBuild, userAssignmentsChanged: editedBuild.user_build_assignments.length > 0 });
    dataModel.dataChanged = editedBuild.user_build_assignments.length > 0 || this.state.nameChanged;
  }

  handleNotifyMultipleSelection(multipleSelections, selectedOption) {
    this.makeUserAssigments('notify', multipleSelections, selectedOption);
  }

  handleBuildOwnerSelection(type, option) {
    if (option && option.selected) {
      this.setState({ currentBuildOwners: [...this.state.currentBuildOwners, option.user] });
    }
    else if (option && !option.selected) {
      const currentBuildOwners = [...this.state.currentBuildOwners].filter(bos => bos.id != option.type);
      this.setState({ currentBuildOwners });
    }
  }

  getLocations() {
    const { project } = this.props;
    const { locations, currentMarketId } = this.state;
    if ((!locations || currentMarketId != project.market_id) && project.market_id) {
      this.setState({ loadingLocations: true });
      this.locationsDataSource = new CollectionDataSource('LocationsCollection', 'Location', location_shallow, this.handleLocationsRetrieval,
        'BuildLocations', 12, null, this.props.currentUser.id, this.props.currentCompany.id, 'market_' + project.market_id, null,
        location_shallow, project.market_id);
      this.locationsDataSource.current();
    }
  }

  createLocationOptions = () => {
    const { locations } = this.state;
    if (!locations || locations.length === 0) {
      return [];
    }
    return locations.map(location => ({
      type: location.id,
      name: location.name,
      location: location,
    }));
  };

  handleLocationSelection(type, option) {
    const { project } = this.props;
    const { editBuild } = this.state;
    let currentLocation;
    let locationChanged;
    if (project.location_id && project.location_id == option.location.id) {
      // project has location and selected option is the same...
      currentLocation = project.location;
      locationChanged = false;
      delete editBuild.location;
    } else {
      // either project does not have location or selected option is different
      currentLocation = option.location;
      locationChanged = true;
      editBuild.location = option.location;
    }
    this.setState({ currentLocation, locationChanged, editBuild });
  }

  handleLocationAdd(options){
    if(this.state.totalLocation > options.length){
      this.setState({ loadingLocations: true });
      this.locationsDataSource.next().then(()=>{
        this.setState({ loadingLocations: false });
      });
    }
  }

  render() {
    const { left, top, width, project } = this.props;
    const { editBuild, loadingLocations, currentLocation, locationsList } = this.state;
    let style = {
      left: left + 'px', top: top + 'px', width: width + 'px',
      height: '214px',
    };

    let connector = <hr className={this.props.connectorClass} />;

    let notifyUsers = null;

    let notificationSelector = null;
    let notifyAvatars = null;
    notifyUsers = editBuild.user_build_assignments ? editBuild.user_build_assignments.filter(user_build_assignment => {
      if (!user_build_assignment.user) {
        // TODO: should not be making API calls in render()
        user_build_assignment.user = dataModel.usersDAO.getUser(user_build_assignment.user_id);
      }
      if (user_build_assignment.user && user_build_assignment.assignment_type == 'notify' && !user_build_assignment.toBeDeleted) {
        return true;
      }
      else {
        return false;
      }
    }).map(ut => {
      return ut.user;
    }) : [];

    if (notifyUsers.length > 0) {
      const notifyImages = this.createNotifyMemberArray(notifyUsers, 'notify');
      notifyAvatars = <div className="member-display">
        <div className="member-array">
          {notifyImages}
        </div>
      </div>;
    }

    let possibleBuildOwners = !project.users ? [] : project.users.filter(user => {
      if (!user.role) {
        if (user.company_vendor_users) {
          const vendor_user = user.company_vendor_users.filter(cvu => {
            return cvu.vendor_user.id == user.id;
          });
          if (vendor_user.length > 0) {
            return vendor_user[0].role && (vendor_user[0].role.name == 'editor' || vendor_user[0].role.name == 'admin');
          }
          return false;
        }
        return false;
      }
      else {
        return (user.role.name == 'editor' || user.role.name == 'admin');
      }
    });

    let selectBuildOwnerComboBox = null;
    let buildOwnerSelector = null;
    if (this.state.editBuild) {
      selectBuildOwnerComboBox = 
        <div className="field">
          <SelectUserComboBox 
            key="build-owner-user" 
            width={245} 
            hasBorder={false} 
            multiSelect={true}
            height={24} 
            menuBelow={true} 
            useMultiTab={true} 
            small={true}
            displayFontStyle={{ fontSize: '13px' }}  
            handleMultipleSelection={this.handleBuildOwnerSelection}
            selectedUsers={this.state.currentBuildOwners}
            users={possibleBuildOwners} 
            dontFocus={true}
          />
        </div>;

      buildOwnerSelector = <div className="entry-field combo">
          <div className="label">Build Owner</div>
          {selectBuildOwnerComboBox}
        </div>;
    }

    let selectNotifiersComboBox = null;
    if (this.state.editBuild) {
      selectNotifiersComboBox = 
        <div className="field">
          <SelectUserComboBox 
            key="notify-user" 
            width={245} 
            hasBorder={false} 
            multiSelect={true}
            height={24} 
            selectedUsers={notifyUsers} 
            menuBelow={true} 
            useMultiTab={true}
            handleMultipleSelection={this.handleNotifyMultipleSelection} 
            small={true}
            displayFontStyle={{ fontSize: '13px' }}  
            users={project.users} 
            dontFocus={true}
          />
        </div>;
    }

    if (notifyUsers.length > 0 || this.state.editBuild) {
      notificationSelector = <div className="entry-field combo">
        <div className="label">Notify After Completion</div>
        {selectNotifiersComboBox}
        {notifyAvatars}
      </div>;
    }
    style.position = 'absolute';
  
    const disabled = !(this.state.currentLocation && this.state.nameChanged);
    let saveButton = <div className={'save-button' + (disabled ? ' disabled' : '')} onClick={!disabled ? this.handleCreateBuild : null}>{this.textMap.save.toUpperCase()}</div>;
    let cancelButton = <div className='cancel-button' onClick={this.handleClearBuild}>{this.textMap.cancel.toUpperCase()}</div>;
    const action = <div className='actions'>
      {cancelButton}
      {saveButton}
    </div>;

    return (
      <div id={this.props.id} className='new-card-container' style={style} onClick={this.handleClick} >
        {connector}
        <div className="entry-field">
          <div className="card-caption field">
            <Input className="input-field build-title-input" value={this.state.editBuild.name} onChange={this.handleNameChanged} onKeyDown={this.handleKeyDown}
              ref={(element) => {
                this.titleInput = element;
              }} placeholder="Build Name" />
          </div>
        </div>
        <div className="entry-field combo">
          <div className="label">Location</div>
          <div className="field combo">
            <ComboBox
              id={'locationPicker'}
              key={'locationPicker'}
              options={locationsList}
              showSearchBar={true}
              currentOption={currentLocation ? { type: currentLocation.id, name: currentLocation.name, location: currentLocation } : null}
              hasBorder={false}
              underlined={false}
              defaultText={loadingLocations ? this.textMap.noneSelected : this.textMap.selectALocation}
              width={245} 
              height={24} 
              small={true}
              handleAddOption={this.handleLocationAdd}
              displayFontStyle={{ fontSize: '12px' }}
              handleSelection={this.handleLocationSelection}
              placeHolderText={this.textMap.location}
              clearSelected={true}
              disabled={!locationsList || locationsList.length == 0}
            />
            { loadingLocations && <LoadingDots/> }
          </div>
        </div>
        {buildOwnerSelector}
        {notificationSelector}
        {action}
      </div>
    );
  }
}

const mapStateToProps = (state) => {

  return {
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default withRouter(connect(mapStateToProps)(NewBuildCard));



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectHierarchy/NewBuildCard/index.js